import { Button } from "@headlessui/react";
import { CSSProperties } from "react";

export const ConfirmButton = ({
  children,
  className,
  onClick,
  disabled,
  style = {},
  otherProps,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: Function;
  disabled?: any;
  otherProps?: any;
  style?: CSSProperties;
}) => (
  <>
    <Button
      className={`py-2 px-8 rounded bg-[#228800] text-white data-[hover]:bg-[#226600] data-[active]:bg-[#228800] ${className}`}
      onClick={onClick}
      style={style}
      {...otherProps}
      disabled={disabled}
    >
      {children}
    </Button>
  </>
);
